import React from "react";
import "./statustag.css";

const tagStyles = {
  Filled: "tag-filled",
  Submitted: "tag-submitted",
  Approved: "tag-approved",
  Rejected: "tag-rejected",
};

const StatusTag = ({ status, label, style, onClick }) => {
  const tag = tagStyles[status];

  return (
    <span
      className={`care-plan-tags ${tag}`}
      style={style}
      onClick={onClick}
    >
      {label}
    </span>
  );
};

export default StatusTag;
